import React, { useState, useEffect } from "react";
import noimage from "../../../../assets/img/noimage.jpg";
import CustomPagination from "../../../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import { fetchNewsList, setCurrentPage, updateNewsStatus, setError, setSuccess } from "../../../reducers/companyContentManage";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { formatDateTime, maxLengthText, getMarkdownExcerpt, getPeriodicTaskStatus } from "../../../utils/format";
import { PERMISSIONS, NEWS_STATUS_OPTIONS, NEWS_STATUS_OPTION_TYPE, STAFF_TYPE } from '../../../constants/index';
import CustomButton from "../../../components/CustomButton";
import Dropdown from "../../../components/Dropdown";
import { getOptionsMaster } from "../../../reducers/companyContent";
import { useSnackbar } from "notistack";
import CustomToast from "../../../components/CustomToast";
import { InfoIcon } from "../../../components/Icons";

const tableHeaders = [
  {
    title: "サムネイル",
    isSort: false,
    minWidth: 110,
  },
  {
    title: "タイトル",
    isSort: false,
    minWidth: 220,
  },
  {
    title: "本文",
    isSort: false,
    minWidth: "",
  },
  {
    title: "ステータス",
    isSort: false,
    minWidth: 160
  },
  {
    title: "公開日時",
    isSort: false,
    minWidth: 128
  },
  {
    title: "",
    isSort: false,
    minWidth: 150,
  },
  {
    title: "",
    isSort: false,
    minWidth: 100,
  },
];

const contentStatusOptions = [
  {
    id: 1,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <circle cx="6" cy="6" r="6" fill="#06C270" />
      </svg>
    ),
    name: "公開",
    value: NEWS_STATUS_OPTIONS.PUBLIC,
  },
  {
    id: 2,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <circle cx="6" cy="6" r="6" fill="#FFC700" />
      </svg>
    ),
    name: "非公開",
    value: NEWS_STATUS_OPTIONS.PRIVATE,
  },
  {
    id: null,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <circle cx="6" cy="6" r="6" fill="#BBBBBB" />
      </svg>
    ),
    name: "公開予約",
    value: "news_scheduled",
    disabled: true,
    hidden: true,
  },
];

const ContentList = ({list}: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  // const {staffInfo} = useSelector((state: any) => state.currentUser);
  const currentUser = useSelector((state: any) => state.currentUser);
  const { staffPermission, staffInfo } = currentUser;
  const {
    error, success, newsList, currentPage,
    countItems, pageSize, actionName, isReload, actionStatus,
  } = useSelector((state: any) => state.companyContentManage);
  const { optionsMaster } = useSelector((state: any) => state.companyContent);
  const [newsStatus, setNewsStatus] = useState(contentStatusOptions);

  useEffect(() => {
    const data = {
      page: currentPage,
      pageSize: pageSize,
    }
    dispatch(fetchNewsList(data));
    dispatch(getOptionsMaster({option: NEWS_STATUS_OPTION_TYPE}));
  }, [isReload]);

  useEffect(() => {
    if (optionsMaster && Object.keys(optionsMaster).length > 0) {
      const dynamicStatusOptions = optionsMaster
        .filter((option: any) => option.name === NEWS_STATUS_OPTION_TYPE)
        .flatMap((option: any) =>
          option.option_list.map((subOption: any) => ({
            id: subOption.id,
            name: subOption.label,
            value: subOption.value,
          }))
        );

      const updatedStatus = newsStatus.map(status => {
        const matched = dynamicStatusOptions.find(
          opt => opt.value === status.value
        );

        if (matched) {
          return {
            ...status,
            id: matched.id,
            name: matched.name,
          };
        }

        return status;
      });

      setNewsStatus(updatedStatus);
    }
  }, [optionsMaster]);
  
  const handleChangePage = (pageNumber: any, pageSizeInput: any) => {
    const data = {
        page: pageNumber,
        pageSize: pageSize,
    }
    dispatch(fetchNewsList(data));
    dispatch(setCurrentPage(pageNumber));
  };

  const getSelectedStatusOption = (item) => {
    if (!item.is_public && item.is_public_scheduled && item.news_status_display.value == NEWS_STATUS_OPTIONS.PUBLIC) {
      return newsStatus.find(option => option.value === 'news_scheduled');
    }

    return newsStatus.find(option => option.id === item.status);
  };

  const getAccessStatusOption = (item) => {
    if(staffInfo?.type == STAFF_TYPE.GENERAL) {
      return true
    }
    if (item.news_status_display.value == NEWS_STATUS_OPTIONS.PRIVATE) {
      return true
    }
    if(!item.is_public && item.is_public_scheduled && item.news_status_display.value == NEWS_STATUS_OPTIONS.PUBLIC) {
      return true
    }

    return false
  };

  interface newsItem {
    id: number;
    thumbnail: string;
    title: string;
    publicationDate: string;
    mainText: string;
    action1: {
      name: string;
      action: any;
    };
    action2: {
      name: string;
      action: any;
    };
  }

  const newsListData: newsItem[] = newsList.map((item: any) => ({
    ...item,
    thumbnail: item.images ? item.images : noimage,
    mainText: item.contents,
    publicationDate: item.is_public_scheduled && item.public_schedule_date ? item.public_schedule_date : item.public_date,
    periodicTaskStatus: getPeriodicTaskStatus(item.periodic_task_status),
    action1: {
      name: "プレビュー",
      action: () => {
        navigate("/company/news/detail/" + item.id);
      },
    },

    action2: {
      name: "編集",
      action: () => {
        navigate("/company/news/edit/" + item.id);
      },
    },
  }));

  const handleUpdateNewsStatus = (status_id, item) => {
    if (status_id == item.status) return;
    dispatch(updateNewsStatus({formData: {id: item.id, status_id: status_id}}));
  }

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  useEffect(() => {
    if ((actionStatus == 'fulfilled' || actionStatus == 'rejected') 
        && (actionName == 'updateNewsStatus') 
        && (error || success)) {
      enqueueSnackbar("I love snacks.", {
        content: (key) => (
          <CustomToast
            title={"メッセージ"}
            message={error ? error : success}
            variant={error ? "error" : "success"}
            snackbarKey={key}
            closeSnackbar={closeSnackbar}
          />
        ),
      });
      dispatch(setError(null));
      dispatch(setSuccess(null));
    }
  }, [actionStatus, actionName, error, success]);

  return (
    <>
      <h2 className="mb-4 text-base font-bold alu-text-base-2">
        コンテンツ一覧
      </h2>
      <div className="bg-white mb-4 rounded-2xl">
        <table className="table-auto w-full">
          <thead className="border-b alu-border px-4 py-2">
            <tr>
              {tableHeaders.map((header, idx) => (
                <th
                  key={idx}
                  className={`px-4 py-2 text-left ${
                    header.minWidth ? `min-w-[${header.minWidth}px]` : ""
                  }`}
                >
                  <div className="flex items-center">
                    <p className="font-normal text-sm leading-[1.3125] alu-text-base-1">
                      {header.title}
                    </p>
                    {header.isSort && (
                      <button>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_8574_176)">
                            <path d="M7 10L12 15L17 10H7Z" fill="#808080" />
                          </g>
                          <defs>
                            <clipPath id="clip0_8574_176">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {newsListData.map((item, idx) => (
                <tr key={idx} className="group">
                  <td className="min-w-[110px] px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">
                    <img
                      onClick={() => item.action1.action()}
                      className="w-[4.5rem] h-[4.5rem] object-cover group-hover:opacity-80 cursor-pointer"
                      src={item.thumbnail}
                      alt={`thumbnail-${idx}`}
                    />
                  </td>
                  <td 
                    className=" min-w-[220px] px-4 py-2 text-left font-bold text-base align-top"
                  >
                    <p onClick={() => item.action1.action()} className="hover:cursor-pointer whitespace-pre-wrap text-link-with-hover group-hover:underline underline-offset-1 cursor-pointer alu-text-base-2">{maxLengthText(item.title, 40)}</p>
                    {item?.periodicTaskStatus && (
                      <div className="mt-1 flex gap-1">
                        <span className="mt-[2px]"><InfoIcon /> </span>
                        <span className="alu-text-base-2 text-xs font-normal alu-text-error whitespace-pre-wrap">{item?.periodicTaskStatus}</span>
                      </div>
                    )}
                  </td>
                  <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 align-top">
                    <div className="whitespace-pre-wrap line-clamp-2">
                      {getMarkdownExcerpt(item.mainText)}
                    </div>
                  </td>
                  <td className="w-[10rem] px-4 py-2 text-left font-normal text-sm leading-[1.3125] align-top">
                    <Dropdown
                      customStyle={`pr-[0.125rem] !bg-[#F7F7F7] ${staffInfo?.type == STAFF_TYPE.GENERAL ? "" : "hover:!bg-[#FFF3E5]"}`}
                      inputWidth="full"
                      options={newsStatus}
                      value={getSelectedStatusOption(item)}
                      onChange={(value: any) => handleUpdateNewsStatus(value.id, item)}
                      disabled={getAccessStatusOption(item)}
                    />
                  </td>
                  <td className="min-w-[128px] px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 align-top">
                    {formatDateTime(item.publicationDate)}
                  </td>
                  <td
                    onClick={() => item.action1.action()}
                    className="min-w-[150px] px-4 py-2 text-left font-normal text-sm leading-[1.3125] align-top"
                  >
                    <CustomButton variant="text" size="sm">
                      {item.action1.name}
                    </CustomButton>
                  </td>
                  {staffPermission[PERMISSIONS.NEWS_EDIT] && (
                  <td 
                    onClick={() => item.action2.action()}
                    className="min-w-[100px] px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-title align-top"
                  >
                    <CustomButton variant="text" size="sm">
                      {item.action2.name}
                    </CustomButton>
                  </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {countItems > pageSize && (
      <div className="flex items-center justify-center">
        <CustomPagination 
          total={countItems} 
          currentPage={currentPage}
          pageSize={pageSize} 
          onPageChange={handleChangePage} 
        />
      </div>
      )}
    </>
  );
};

export default ContentList;
